import { render } from "./timeExpired.vue?vue&type=template&id=b40f4ad0&scoped=true"
import script from "./timeExpired.vue?vue&type=script&lang=js"
export * from "./timeExpired.vue?vue&type=script&lang=js"

import "./timeExpired.vue?vue&type=style&index=0&id=b40f4ad0&scoped=scoped&lang=less"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b40f4ad0"]])

export default __exports__